import { useState, useCallback, useEffect } from 'react';

export function useMuteList() {
  const [mutedPubkeys, setMutedPubkeys] = useState<Set<string>>(() => {
    try {
      const saved = localStorage.getItem('bchnostr:muted');
      return new Set(saved ? JSON.parse(saved) : []);
    } catch { return new Set(); }
  });

  useEffect(() => {
    localStorage.setItem('bchnostr:muted', JSON.stringify([...mutedPubkeys]));
  }, [mutedPubkeys]);

  const mute = useCallback((pubkey: string) => {
    setMutedPubkeys(prev => new Set([...prev, pubkey]));
  }, []);

  const unmute = useCallback((pubkey: string) => {
    setMutedPubkeys(prev => {
      const next = new Set(prev);
      next.delete(pubkey);
      return next;
    });
  }, []);

  const isMuted = useCallback((pubkey: string) => mutedPubkeys.has(pubkey), [mutedPubkeys]);

  return { mutedPubkeys, mute, unmute, isMuted };
}

